export default __webpack_public_path__ + "static/media/494.748eb960.jpg";